<template>
	<div>
		<Header :isHome="false"></Header>
		
		<div class="container" style="padding-top: 6rem;">
			<!-- 路由导航栏 -->
			<div class="row" style="padding-left: 15px;padding-right: 15px;margin-bottom: 2rem;">
				<div class="" style="font-size: 1rem;font-weight: 500;">
					<span style="cursor: pointer;" class="hover-light" @click="toHome">home</span><span class="" style="margin: 0 0.5rem;">></span>
					<span style="cursor: pointer;" class="hover-light" @click="todemandmain">Project Sourcing</span><span class="" style="margin: 0 0.5rem;">></span>
					<span>Demand Details</span>
				</div>
			</div>
			<div class="row">
				<div class="col-9">
					<div style="background-color: #fff;border: 1px solid #D1D1D1;padding: 1.5rem;display: flex;border-radius: 1rem;">
						<div style="display: flex;flex-direction: column;width: 100%;">
							
							<!-- 内容顶部 -->
							<div style="display: flex;align-items: center;justify-content: space-between;font-size: 1rem;font-weight: 500;margin-bottom: 1rem;">
								<div style="display: flex;align-items: center;">
									<div style="min-width: 3rem;height: 3rem;border-radius: 50%;margin-right: 1rem;background-position: center;background-size: cover;background-repeat: no-repeat;" 
											:style="{backgroundImage: 'url('+data.user.avatar+')'}"></div>
									<div style="">{{data.user.username}}</div>
								</div>
								<div style="display: flex;align-items: center;cursor: pointer;" class="hover-light" @click="collect">
									<img :src="data.collected?require('../../assets/imgs/news/icon-star-light.svg'):require('../../assets/imgs/news/icon-star.svg')"
											style="width: 1.5rem;height: 1.5rem;margin-right: 0.3rem;">
									<!-- collect -->
								</div>
							</div>
							
							<!-- 需求详情 -->
							<div style="font-size: 1rem;color: #101010;;margin-bottom: 0.5rem;user-select:none">
								{{data.content}}
							</div>
							
							<!-- 标签 -->
							<div style="color: #959595;margin-bottom: 2rem;font-size: 0.9rem;user-select:none">
								# {{data.classify.title}} 
							</div>
							
							<!-- 图片 -->
							<div style="display: flex;flex-wrap: wrap;">
								<div style="min-width: 9rem;height: 9rem;margin-right: 0.5rem;margin-bottom: 0.5rem;background-position: center;background-size: cover;background-repeat: no-repeat;
									cursor: pointer;" :style="{backgroundImage: 'url('+img+')'}" v-for="(img, imgindex) in data.images"  @click="largeimg(data.images, imgindex)"></div>
							</div>
							
							<!-- 其他 -->
							<div style="color: #5F5F5F;font-size: 0.9rem;margin-bottom: 1rem;">
								<div style="margin-bottom: 0.5rem;">Demand deadline：{{data.expireTime | formatDate}}</div>
								<div>Email：{{data.contact}}</div>
							</div>
							
							<div v-if="data.attachment.length>0" style="display: flex;justify-content: space-between;align-items: center;">
								<!-- 附件 -->
								<div style="width: fit-content;font-size: 0.9rem;" class="btn-normal" @click="downloadd(data.attachment[0])">
									<img src="../../assets/imgs/demand/download_icon.svg" style="width: 1rem;height: 1rem;margin-right: 0.5rem;">Download file
								</div>
								
								<div style="display: flex;align-items: center;">
									<!-- 是否超时 -->
									<div style="color: #FF2626;" v-show="data.status==3">expired</div>
									
									<!-- 编辑 -->
									<!-- <div style="width: fit-content;font-size: 0.9rem;margin-left: 1rem;" class="btn-normal" @click="publishboxshow(2)" v-if="editshow">
										Revise
									</div> -->
									
									<!-- 开关 -->
									<!-- <div style="position: relative;">
										<div style="width: fit-content;font-size: 0.9rem;margin-left: 0rem;margin-right: 0;" class="btn-normal" @click="changestateboxshow=!changestateboxshow" v-if="editshow">
											{{data.state?'open demand':'close demand'}}
										</div>
										<div class="fadeIn animated" style="position: absolute;left: 0;top: 2.5rem;background-color: #fff;padding: 1rem;border-radius: 0.75rem;box-shadow: 1px 3px 2px 1px rgba(0,0,0,0.06);
												width: -webkit-fill-available" v-show="changestateboxshow">
											<div class="hover-light" style="cursor: pointer;" @click="changestate(true)">open</div>
											<div class="hover-light" style="cursor: pointer;" @click="changestate(false)">close</div>
										</div>
									</div> -->
								</div>
							</div>
							
						</div>
					</div>
					
					<div class="" style="font-size: 1rem;font-weight: 500;margin:1rem 0">
						<span>Similar Demands</span>
					</div>
					
					
					<!-- <div class="hover-up transition-normal fadeIn animated supplier-box" style="background-color: #fff;padding: 1rem;display: flex;margin-bottom: 2rem;border-radius: 1rem;"
							v-for="(item, index2) in data" :key="index2">
						<div :style="{backgroundImage: 'url('+item.coverImage+')'}" @click="tosupplierdetail(item)" style="cursor: pointer;" class="main-img"></div>
						<div style="display: flex;flex-direction: column;width: 100%;position: relative;">
							<div style="cursor: pointer;" class="main-title" @click="tosupplierdetail(item)" v-text="item.providerName"></div>
							<div style="font-size: 0.7rem;color: #666;cursor: pointer;" @click="tosupplierdetail(item)" class="supplier-desc" v-text="item.providerDescription"></div>
							<div style="display: flex;justify-content: flex-end;margin-top: 1rem;" v-if="!isMobile">
								<div style="color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
										font-weight: bold;width: 6rem;cursor: pointer;position: absolute;right: 0;bottom: 0;"
										:class="{'btn-cyan':!item.follow, 'btn-lightgreen':item.follow}" @click="changefollow(item)" v-text="item.follow?'UnFollow':'Follow'"></div>
							</div>
						</div>
					</div> -->
					
					<div class="hover-up transition-normal fadeIn animated supplier-box" v-if="item.user.username!=data.user.username" style="background-color: #fff;padding: 2rem;display: flex;margin-bottom: 2rem;border-radius: 1rem;cursor: pointer;"
							v-for="(item, index2) in topdata" :key="index2" @click="todemanddetail(item)">
						<div style="display: flex;flex-direction: column;width: 100%;position: relative;">
							<div style="display: flex;align-items: center;margin-bottom: 1rem;">
								<div :style="{backgroundImage: 'url('+item.user.avatar+')'}" style="" class="main-img"></div>
								<div style="" class="main-title" v-text="item.user.username"></div>
							</div>
							<!-- <div style="display: flex;flex-wrap: wrap;cursor: pointer;" @click="tosupplierdetail(item)">
								<div v-for="(c, index3) in item.certifications" :key="index3" style="padding:0rem 0.5rem;border: 1px solid #D8D8D8;border-radius: 2rem;font-size: 0.5rem;
								display: flex;align-items: center;justify-content: center;margin-right: 0.5rem;margin-bottom: 0.5rem;" v-text="c.name"></div>
							</div> -->
							<div style="font-size: 1rem;color: #000;margin-bottom: 1rem;" class="supplier-desc" v-text="item.content"></div>
							<!-- <div style="display: flex;justify-content: flex-end;margin-top: 1rem;" v-if="!isMobile">
								<div style="color: #333;font-size: 0.8rem;display: flex;align-items: center;justify-content: center;border-radius: 3rem;padding: 0.4rem 0.7rem;
										font-weight: bold;width: 6rem;cursor: pointer;position: absolute;right: 0;bottom: 0;"
										:class="{'btn-cyan':!item.follow, 'btn-lightgreen':item.follow}" @click="changefollow(item)" v-text="item.follow?'UnFollow':'Follow'"></div>
							</div> -->
							<div style="font-size: 0.8rem;color: #666;margin-bottom: 1rem;">
								# {{item.classify.title}}
							</div>
							
							<div style="display: flex;justify-content: space-between;align-items: center;">
								<div>
									Deadline: {{item.expireTime | formatDate}}
								</div>
								<div class="btn-cyan-liner" style="padding: 0.4rem 1rem;border-radius: 5rem;font-size: 0.8rem;font-weight: 500;">
									more
								</div>
							</div>
						</div>
					</div>
					
					<!-- 空状态 -->
					<div v-show="topdata.length==0" class="nodata-box">
						<img src="../../assets/imgs/nodata.svg" class="nodata-img">
					</div>
					
					<div style="display: flex;align-items: center;justify-content: center;margin-bottom: 2rem;margin-top: 1rem;">
						<div class="btn-cyan-liner" style="padding: 0.4rem 1.5rem;font-size: 1rem;border-radius: 0.2rem;cursor: pointer;" @click="todemandmain">All demands</div>
					</div>
					
				</div>
				
				<div class="col-3" style="padding: 2rem;background-color: #fff;border: 1px solid #D9D8D8;height: 100%;border-radius: 1rem;">
					<div style="display: flex;flex-direction: column;">
						<div style="font-size: 1.2rem;font-weight: 500;color: #000;margin-bottom: 1rem;">Publish demands</div>
						<div style="font-size: 1rem;color: #101010;margin-bottom: 1rem;">Let more service providers understand your demands</div>
						<div style="border-top: 1px solid #EFEFEF;"></div>
						<div style="margin-top: 1rem;display: flex;align-items: center;margin-bottom: 0rem;">
							<span style="font-size: 1rem;color: #101010;margin-right: 1rem;">Cumulative demands published</span>
						</div>
						<div style="margin-bottom: 2rem;">
							<span style="font-size: 1.2rem;color: #000;font-weight: 500;">{{total}}</span>
						</div>
						<img src="../../assets/imgs/demand/blog-post/bro.svg" style="width: 100%;margin-bottom: 2rem;">
						<div style="width: 100%;display: flex;align-items: center;justify-content: center;color: #000;font-size: 1.2rem;height: 3rem;margin-bottom: 1rem;cursor: pointer;
								border-radius: 0.5rem;font-weight: 500;"
								@click="publishboxshow(1)" class="btn-cyan">
							Publish Now
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 发布需求组件 -->
		<Demandpulish></Demandpulish>
		
		<Footer></Footer>
	</div>
</template>

<script>
			import Header from '/src/components/header.vue'
			import Footer from '/src/components/footer.vue'
			import Demandpulish from '/src/components/demand/demandpulish.vue'
			export default {
				data() {
					return {
						id:'',
						data: {
							user:{
								username:'',
								avatar:''
							},
							classify:{
								title:''
							}
						},
						page: 1,
						perPage: 2,
						islogin:false,
						// total:0,
						isMobile:false,
						demanddata:[],
						topdata:[],
						editshow:false,
						changestateboxshow:false,
						
						total:0
					}
				},
				props:{
				},
				components: {
					Header,
					Footer,
					Demandpulish
				},
				filters:{
					formatDate:function(timestemp){
						let date = new Date(timestemp*1000)
						return date.getFullYear() + '/' + (date.getMonth()+1) +'/'+ date.getDate() 
					}
				},
				methods: {
					collect(){
						this.$bus.$emit('noloading', true)
							let params = {
								demandId:this.data.id
							}
							this.request({
								method: 'post',
								url: '/gci/demand/collection',
								data:params
							}).then(res => {
								if(res.status == 0){
									this.data.collected = !this.data.collected
								}else{
									// alert(res.msg)
								}
							}).catch(error => {
								console.error(error.response)
							})
					},
					getdata(){
						this.request({
							method: 'get',
							url: '/gci/demand/get?demandId='+this.id,
						}).then(res => {
							this.data = res.data
							if(this.data.uid == JSON.parse(localStorage.getItem('user')).uid){
								this.editshow = true
							}
							this.getdatabyistop()
						}).catch(error => {
							console.error(error.response)
						})
					},
					largeimg(imgs, index){
						this.$bus.$emit('largeimg', {show:true, imgs:imgs, index:index})
					},
					toHome(){
						this.$router.push({name:'home'})
					},
					todemandmain(){
						this.$router.push({name:'demandmain'})
					},
					todemanddetail(item){
						// this.$router.push({name:'demanddetail',query:{id:item.id}})
						// location.reload()
						this.id = item.id
						this.getdata()
						window.scrollTo(0,0);
					},
					handleRightClick (event) {
						event.preventDefault()
					},
					publishboxshow(type){
						// 是否登录
						if(this.islogin){
							// this.publishbox = true
							let query = {
								type:type,
								show:true,
							}
							if(type==2){
								query.data = this.data
							}
							this.$bus.$emit('publishbox', query)
						}else{
							// 是否移动端
							if(this.isMobile){
								this.$router.push({name:'mlogin', query:{type:0}})
							}else{
								this.$bus.$emit('login', true)
							}
						}
					},
					getdatabyistop(){
						this.request({
							method: 'get',
							// url: '/gci/demand/topList?classifyId='+this.data.classifyId,
							url: '/gci/demand/list?classifyId='+this.data.classifyId+'&page=1&perPage=6'
						}).then(res => {
							this.topdata = res.data.items
						}).catch(error => {
							console.error(error.response)
						})
					},
					//点击下载
					downloadd(link) {  
					  // if(row.date==1){
						// var a = document.createElement('a') // 创建一个<a></a>标签
						// a.href = link         //重点（如测试发现下载文件不存在/找不到，检查路径）
						// a.download = link        // 设置下载文件文件名
						// a.style.display = 'none'           // 隐藏a标签
						// document.body.appendChild(a)       // 将a标签追加到文档对象中
						// a.click()                          // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
						// a.remove()                        // 一次性的，用完就删除a标签
					  // }    
						   let xhr = new XMLHttpRequest();
						   xhr.onreadystatechange = function () {
							   if (xhr.readyState === 4) {
								   let link = document.createElement("a");
								   let url = window.URL.createObjectURL(xhr.response);
								   link.href = url;
								   link.download = '';
								   link.click();
								   window.URL.revokeObjectURL(url);
							   }
						   }
						   // 需要指定响应类型为 blob
						   xhr.responseType = "blob";
						   xhr.open("get", link);
						   xhr.send();
					},
					changestate(bool){
						let params = {
							state:bool
						}
						this.request({
							method: 'post',
							url: '/gci/demand/'+this.data.id+'/edit',
							data:params
						}).then(res => {
							if(res.status==0){
								this.$bus.$emit('message',{
									type:2,
									msg: 'update success'
								})
								this.data.state = bool
								this.changestateboxshow = false
							}else{
								this.$bus.$emit('message',{
									type:3,
									msg: res.msg
								})
							}
						}).catch(error => {
							console.error(error.response)
						})
					},
					gettotal(){
						this.request({
							method: 'get',
							url: '/gci/demand/list?page=1&perPage=1',
						}).then(res => {
							this.total = res.data.total
						}).catch(error => {
							console.error(error.response)
						})
					}
				},
				created() {
					this.$bus.$emit('laoding', true)
				},
				mounted() {
					localStorage.getItem('isMobile') == 'null'?this.isMobile = false:this.isMobile = true
					let token = localStorage.getItem('token')
					if(token){
						this.islogin = true
					}
					this.id = this.$route.query.id
					this.gettotal()
					// Promise.all([
						this.getdata()
					// ]).then(()=>{
					// 	this.getdatabyistop()
					// })
				}
			}
</script>

<style scoped lang="scss">
	.main-img{
		min-width: 2.5rem;height: 2.5rem;background-position: center center;background-size: cover;background-repeat: no-repeat;border-radius: 50%;margin-right: 1rem;
	}
	.main-title{
		color: #000;font-size: 1.2rem;font-weight: bold;margin-bottom: 0.5rem;
	}
	.supplier-desc{
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	@media (max-width:767px) {
		.row{
			flex-direction: column;
		}
		.col-9{
			max-width: 100%;
		}
		.col-3{
			max-width: calc(100% - 30px);
			margin: 0 15px 1rem 15px;
		}
		.main-img{
			margin-bottom: 1rem;margin-right: 0;
		}
		.main-title{
			font-size: 1.2rem;
		}
	}
	@media (min-width:767px) {
		.col-9{
			// margin-right: 2rem;
		}
	}
</style>